// Component for handeling the interaction with the custom Scenario

// Component for All parameters
// TODO - Documentar

// Global constants
import * as con from "../../GlobalConstants"


import { RefModelParameterHook, StateModelParameterHook } from '../hooks/ModelParameterHooks';
import { fontCalculator } from '../../templates/tables/StaticTable';

// Style
import "../../templates/Templates.css"
import "../../templates/tables/Table.css"
import "../ComponentsGlobalStyle.css"
import { GenericElement } from '../../templates/FormElement';
import { CellMoney, CellText } from '../../templates/tables/Cells';
import { useMemo } from "react";
import { makeSelectScenarioGeneratorById } from "../../store/selectors/scenariosSlectors";
import { useSelector } from "react-redux";


function CustomScenario({fixedSize}) {


    // Parameters
    const numPeriods =  RefModelParameterHook(con.TERM_PERIODICITY)
    

    const [customScenarioValues, setCustomScenarioValues] = StateModelParameterHook(con.CUSTOM_SCENARIO_VALUES)  
    const [customScenarioActive, setCustomScenarioActive] = StateModelParameterHook(con.CUSTOM_SCENARIO_ACTIVE)

    const selectGenerator = useMemo(
        () => makeSelectScenarioGeneratorById(con.SCENARIO_VINCO),
        []
    );
    const generator = useSelector(selectGenerator);

    const setSingleCustomScenarioValue = (i, val) => {
        setCustomScenarioValues(prev => {
            const updated = [...(prev ?? [])];
            updated[i] = val;
            return updated;
        });
    };
    

    return (
    <div className="compact" style={{width : "98%"}}>
        <h4>Valores Escenario</h4> 
        <div className="smallParameterBox" >        
        
            < GenericElement type={con.BOOLEAN}
                id={con.CUSTOM_SCENARIO_ACTIVE} 
                value={customScenarioActive} 
                setValue={setCustomScenarioActive} 
                label={'Activar Personalizado'}                                    
              />  
        
        </div>   
        <div className="contenedor-tabla" style={ fixedSize == null ?{} : {fontSize : fontCalculator(fixedSize, numPeriods+2)}}>

            <div className="flex-tabla">
                <div className="flex-fila header-row">
                    <div className="flex-celda ">PERIODO</div>
                    <div className={`flex-celda`}>VINCO</div>
                    <div className={`flex-celda ${customScenarioActive && "selected-header-cell"}`} >PERS.</div>
                </div>
            </div>

           <div className="flex-tabla"> 
                {
                    [...Array(numPeriods).keys()].map((i) => {
                        return(

                        <div key={i} className={`flex-fila hoverable-row ${(i % 2 === 0)? "even-row":"uneven-row"}`}>            
                            <div className="flex-celda"><CellText value={`Mes ${i+1}`} editing={false}/></div>
                            <div className={`flex-celda`}><CellMoney value={ generator?.(0, (i+1)*con.DAYS_IN_MONTH) } editing={false}/></div>
                            <div className={`flex-celda ${!customScenarioActive && "flex-celda-disabled"}`} >
                                <CellMoney value={ customScenarioValues === null ? generator?.(0, (i+1)*con.DAYS_IN_MONTH) 
                                    : customScenarioValues[i+1] } editing={customScenarioActive} 
                                    setValue={val => setSingleCustomScenarioValue(i+1, val)}/></div>
                        </div>

                        )
                })}            
            </div>
            
        </div>
    </div>
    )
}

CustomScenario.defaultProps = {
    fixedSize : null,
  };



export default CustomScenario